import React from 'react';
import PropTypes from 'prop-types';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';

const RankingsTable = ({
    rankings,
    renderValue,
    outerBoxSx,
    scrollContainerSx,
    tableContainerSx,
    tableSx,
    variant,
}) => {
    if (!rankings || rankings.length === 0) {
        return null;
    }

    const renderCellValue = (value) => {
        if (typeof renderValue === 'function') {
            return renderValue(value);
        }
        return value || 'N/A';
    };

    const isResponsive = variant === 'responsive';

    return (
        <Box sx={{ width: '100%', mt: 2, ...outerBoxSx }}>
            <Box
                sx={{
                    overflowX: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    ...scrollContainerSx,
                }}
            >
                <TableContainer
                    component={Paper}
                    sx={{
                        backgroundColor: '#03263D',
                        borderRadius: 2,
                        boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)',
                        maxWidth: '100%',
                        ...tableContainerSx,
                    }}
                >
                    <Table
                        aria-label="Ranked areas table"
                        sx={{
                             minWidth: isResponsive ? undefined : 900,
                            width: '100%',
                            tableLayout: isResponsive ? 'fixed' : 'auto',
                            ...tableSx,
                        }}
                    >
                        <TableHead>
                            <TableRow
                                sx={{
                                    '& th': {
                                        color: 'white',
                                        fontWeight: 'bold',
                                        whiteSpace: isResponsive ? 'normal' : 'nowrap',
                                        fontSize: isResponsive
                                            ? { xs: '0.7rem', sm: '0.75rem', md: '0.85rem', lg: '0.95rem' }
                                            : '0.95rem',
                                        lineHeight: 1.2,
                                        wordBreak: 'break-word',
                                    },
                                }}
                            >
                                <TableCell>Area</TableCell>
                                <TableCell>Chambers &amp; Partners</TableCell>
                                <TableCell>Legal 500</TableCell>
                                <TableCell>Leaders League</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rankings.map((row) => (
                                <TableRow
                                    key={row.id ?? `${row.Area?.nombre}-${row.cp}-${row.L500}-${row.LL}`}
                                    sx={{
                                        '& td': {
                                            color: 'white',
                                            whiteSpace: isResponsive ? 'normal' : 'nowrap',
                                            fontSize: isResponsive
                                                ? { xs: '0.65rem', sm: '0.7rem', md: '0.8rem', lg: '0.9rem' }
                                                : '0.9rem',
                                            lineHeight: 1.35,
                                            wordBreak: 'break-word',
                                            minHeight: isResponsive ? 64 : 4,
                                            p: isResponsive ? { xs: 0.75, sm: 1 } : undefined,
                                        },
                                    }}
                                >
                                    <TableCell>{row.Area?.nombre}</TableCell>
                                    <TableCell>{renderCellValue(row.cp)}</TableCell>
                                    <TableCell>{renderCellValue(row.L500)}</TableCell>
                                    <TableCell>{renderCellValue(row.LL)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
};

RankingsTable.propTypes = {
    rankings: PropTypes.arrayOf(PropTypes.object),
    renderValue: PropTypes.func,
    outerBoxSx: PropTypes.object,
    scrollContainerSx: PropTypes.object,
    tableContainerSx: PropTypes.object,
    tableSx: PropTypes.object,
    variant: PropTypes.oneOf(['default', 'responsive']),
};

RankingsTable.defaultProps = {
    rankings: [],
    renderValue: undefined,
    outerBoxSx: {},
    scrollContainerSx: {},
    tableContainerSx: {},
    tableSx: {},
    variant: 'default',
};

export default RankingsTable;